import { render, staticRenderFns } from "./brother.vue?vue&type=template&id=1262b256&scoped=true&"
import script from "./brother.vue?vue&type=script&lang=js&"
export * from "./brother.vue?vue&type=script&lang=js&"
import style0 from "./brother.vue?vue&type=style&index=0&id=1262b256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1262b256",
  null
  
)

export default component.exports